import './src/styles/global.css'
// custom typefaces
import 'fontsource-alegreya'
import 'fontsource-alegreya/700.css'
import 'fontsource-nunito-sans/300.css'
import 'fontsource-nunito-sans/700.css'
import 'fontsource-nunito-sans/800.css'
